/* eslint-disable camelcase */
import {
  EEventName,
  ShippingEventInteractiveActions,
  ShippingEventInteractiveCategories,
  ShippingEventInteractivePage,
  ShippingEventInteractivePageNames
} from '@/modules/shared/utils/gtmEvents/types';

export const baseEvent = {
  'event-interactive-category': ShippingEventInteractiveCategories.Checkout,
  'event-interactive-accion': ShippingEventInteractiveActions.Click,
  event: EEventName.EVENT_INTERACTIVE
};

export const pageEvent = {
  page: ShippingEventInteractivePage.Shipping,
  pagename: ShippingEventInteractivePageNames.BuyingProcessDelivery,
  event: EEventName.PAGE_VIRTUAL
};

export const specificEvents = {
  begin_checkout: {},
  products_not_unavailable_shipping: {
    event: EEventName.EVENT_INTERACTIVE
  },
  add_shipping_info: {
    event: EEventName.EVENT_INTERACTIVE
  },
  measure_grouping_leadtime: {
    event: EEventName.EVENT_INTERACTIVE
  },
  checkout: {
    event: EEventName.CHECKOUT
  },
  add_to_cart: {
    event: EEventName.ADD_TO_CART
  },
  remove_from_cart: {
    event: EEventName.REMOVE_FROM_CART
  }
};

export const shippingEvents = {
  baseEvent,
  pageEvent,
  ...specificEvents
};

export default shippingEvents;
